const DAY_MS = 86_400_000;
const DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})(?:T(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d{1,3})?Z)?$/;
export function parseDateUTC(input) {
    if (input instanceof Date) {
        if (Number.isNaN(input.getTime())) {
            throw new RangeError('Invalid UTC date');
        }
        return new Date(Date.UTC(input.getUTCFullYear(), input.getUTCMonth(), input.getUTCDate()));
    }
    const match = DATE_PATTERN.exec(input);
    if (match === null) {
        throw new RangeError(`Invalid UTC date: ${input}`);
    }
    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    const result = new Date(Date.UTC(year, month - 1, day));
    if (result.getUTCFullYear() !== year ||
        result.getUTCMonth() !== month - 1 ||
        result.getUTCDate() !== day) {
        throw new RangeError(`Invalid UTC date: ${input}`);
    }
    return result;
}
export function toDateKeyUTC(input) {
    return parseDateUTC(input).toISOString().slice(0, 10);
}
export function sameUTCDate(left, right) {
    return toDateKeyUTC(left) === toDateKeyUTC(right);
}
export function addDaysUTC(input, days) {
    const date = parseDateUTC(input);
    return new Date(date.getTime() + days * DAY_MS);
}
export function differenceInUTCDays(later, earlier) {
    return Math.floor((parseDateUTC(later).getTime() - parseDateUTC(earlier).getTime()) / DAY_MS);
}
export function daysInUTCMonth(year, month) {
    assertMonth(month);
    return new Date(Date.UTC(year, month, 0)).getUTCDate();
}
export function endOfUTCMonth(input) {
    const date = parseDateUTC(input);
    return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 0));
}
export function addMonthsUTC(input, months) {
    if (!Number.isInteger(months)) {
        throw new RangeError('Months must be an integer');
    }
    const date = parseDateUTC(input);
    const absoluteMonth = date.getUTCFullYear() * 12 + date.getUTCMonth() + months;
    const targetYear = Math.floor(absoluteMonth / 12);
    const targetMonthIndex = ((absoluteMonth % 12) + 12) % 12;
    const targetDay = Math.min(date.getUTCDate(), daysInUTCMonth(targetYear, targetMonthIndex + 1));
    return new Date(Date.UTC(targetYear, targetMonthIndex, targetDay));
}
export function createUTCDate(year, month, day) {
    assertMonth(month);
    return parseDateUTC(`${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`);
}
function assertMonth(month) {
    if (!Number.isInteger(month) || month < 1 || month > 12) {
        throw new RangeError('Month must be an integer between 1 and 12');
    }
}
//# sourceMappingURL=dates.js.map